// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common_button_switch[data-v-204d971e]{position:relative;width:34px;height:16px;cursor:pointer;background-color:#bfc0cd;border-radius:8px}.common_button_switch[data-v-204d971e]:before{position:absolute;top:2px;left:2px;width:12px;height:12px;content:\"\";background-color:#fff;border-radius:50%}.common_button_switch.active[data-v-204d971e]{background-color:#7c88fe}.common_button_switch.active[data-v-204d971e]:before{right:2px;left:auto}", ""]);
// Exports
module.exports = exports;
